@if (shouldShowLayout) {
<app-layout-vertical>
  <router-outlet />
</app-layout-vertical>
} @else {
<router-outlet></router-outlet>
}
@if (isLoading) {
<app-spinner />
}